import { gql } from "@apollo/client"
import { DestroyDocumentInput, DestroyDocumentPayload } from "@oysterhr/schema"
import { useMutation, InjectedOptions } from "@oysterhr/core"
import { SetRequired } from "type-fest"

export const GENERAL_STAFF_DESTROY_DOCUMENT = gql`
  mutation DestroyDocument($documentId: String!) {
    destroyDocument(input: { documentId: $documentId }) {
      errors
    }
  }
`

type MutationOptions = SetRequired<
  InjectedOptions<DestroyDocumentPayload, DestroyDocumentInput>,
  "refetchQueries"
>

const useDestroyDocument = (options: MutationOptions) =>
  useMutation<DestroyDocumentPayload, DestroyDocumentInput>(GENERAL_STAFF_DESTROY_DOCUMENT, options)

export default useDestroyDocument
